import { AlarmCriterion } from './alarm-criterion'
// Type options for dropdown
export const typeOptions = [
  { label: 'Placa de Veículo', value: 'LICENSE-PLATE' },
  { label: 'Cor do Veículo', value: 'COLOR' },
  { label: 'Tipo de Veículo', value: 'TYPE' },
]

export const categoryOptions = [
  { label: 'Veículos', value: 'ANPR', icon: 'pi pi-car' },
  { label: 'Pessoas', value: 'AHCR', icon: 'pi pi-users' },
]

export const genderOptions = [
  { label: 'Masculino', value: 'male' },
  { label: 'Feminino', value: 'female' },
]

export const sleeveLengthOptions = [
  { label: 'Manga Longa', value: 'longSleeve' },
  { label: 'Manga Curta', value: 'shortSleeve' },
]

export const trouserLengthOptions = [
  { label: 'Calça', value: 'longTrousers' },
  { label: 'Bermuda', value: 'shortTrousers' },
]

export const vehicleTypeOptions = [
  { label: 'Moto', value: 'bikes' },
  { label: 'Ônibus', value: 'buses' },
  { label: 'Carro', value: 'cars' },
  { label: 'Caminhão', value: 'trucks' },
  { label: 'Desconhecido', value: 'unknown' }
]

export const alarmColors = [
  { name: 'Preto', hex: '#000000', value: 'Black' },
  { name: 'Branco', hex: '#ffffff', value: 'White' },
  { name: 'Cinza', hex: '#6b7280', value: 'Gray' },
  { name: 'Azul', hex: '#3b82f6', value: 'Blue' },
  { name: 'Vermelho', hex: '#ef4444', value: 'Red' },
  { name: 'Verde', hex: '#22c55e', value: 'Green' },
  { name: 'Amarelo', hex: '#eab308', value: 'Yellow' },
  { name: 'Laranja', hex: '#f97316', value: 'Orange' },
  { name: 'Rosa', hex: '#ec4899', value: 'Pink' },
  { name: 'Roxo', hex: '#a855f7', value: 'Purple' },
  { name: 'Marrom', hex: '#92400e', value: 'Brown' },
  { name: 'Bege', hex: '#d4a574', value: 'Beige' },
]

export const blankAlarmCriterion: AlarmCriterion = {
  id: '',
  category: 'ANPR',
  type: 'LICENSE_PLATE',
  value: '',
  displayValue: '',
}
